import React, { useState } from "react";
import Hero_Image from "../images/hero_image.svg";
import MultiStepForm from "../components/MultiStepForm";
import useAuthPopup from "../components/useAuthPopup";
const MainMobile = () => {
  const { isPopupOpen, handleOpenPopup, handleClosePopup } = useAuthPopup();
  const [expandedIndex, setExpandedIndex] = useState(null);

  const questions = [
    "Do you charge any extra brokerage per order?",
    "I have a feature request, where should I reach out?",
  ];

  const answers = [
    "No, you only pay what you are paying for your broker!",
    "You can reach out to our inbox through mail hello@optiongeeks.in, provide us with a brief of your feature request, and we will surely try to integrate it!",
  ];

  const handleToggleAnswer = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  return (
    <div className="">
      {isPopupOpen && <div className="popup-backdrop"></div>}
      <div
        className="grid-container-mobile banner-left"
        style={{ marginTop: "120px" }}>
        <div>
          <h1 className="text-center">
            All in one tool for <span className="exclusive">F&O</span> traders
          </h1>
          <div className="banner-desc text-center">
            Strategy creator + Option chain + Iceberg orders + Scalp orders +
            Position analytics & much more!
          </div>
        </div>
        <img
          className=" hero_image"
          src={Hero_Image}
          alt="banner for the portal"
        />
        <div className="text-center">
          <button
            className="custom-width login-btn btn fw-medium"
            onClick={handleOpenPopup}>
            Continue with broker
          </button>
          <div className="btn-text">
            Login directly with your broker accounts
          </div>
        </div>
      </div>

      <div className="grid-container-mobile">
        <div className="features-h1 mb-3">Why OptionGeeks?</div>
        <div className="d-flex flex-column gap-3">
          <div className="why-op-box d-flex flex-column gap-2 justify-content-center px-3">
            <div className="box-title d-flex align-items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="17"
                viewBox="0 0 14 17"
                fill="none">
                <path
                  d="M7.18442 1L1.10547 10.5455H7.18442V16L13.2634 6.45455H7.18442V1Z"
                  stroke="black"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div>Speed</div>
            </div>
            <div className="box-description">
              Fastest computation of data, you would love the speed!
            </div>
          </div>
          <div className="why-op-box d-flex flex-column gap-2 justify-content-center px-3">
            <div className="box-title d-flex align-items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none">
                <path
                  d="M12.8031 9.16669C13.096 8.8738 13.096 8.39893 12.8031 8.10603C12.5102 7.81314 12.0353 7.81314 11.7424 8.10603L12.8031 9.16669ZM8.25 2.45455C8.25 2.86876 8.58579 3.20455 9 3.20455C9.41421 3.20455 9.75 2.86876 9.75 2.45455H8.25ZM15.5455 8.25C15.1312 8.25 14.7955 8.58579 14.7955 9C14.7955 9.41421 15.1312 9.75 15.5455 9.75V8.25ZM2.45455 9.75C2.86876 9.75 3.20455 9.41421 3.20455 9C3.20455 8.58579 2.86876 8.25 2.45455 8.25V9.75ZM4.43942 2.65149C4.14653 2.35859 3.67165 2.35859 3.37876 2.65149C3.08587 2.94438 3.08587 3.41926 3.37876 3.71215L4.43942 2.65149ZM4.40728 4.74067C4.70017 5.03356 5.17505 5.03356 5.46794 4.74067C5.76083 4.44777 5.76083 3.9729 5.46794 3.68001L4.40728 4.74067ZM14.9225 3.71215C15.2154 3.41926 15.2154 2.94438 14.9225 2.65149C14.6296 2.35859 14.1547 2.3586 13.8618 2.65149L14.9225 3.71215ZM12.8333 3.68001C12.5404 3.9729 12.5404 4.44777 12.8333 4.74067C13.1262 5.03356 13.6011 5.03356 13.8939 4.74067L12.8333 3.68001ZM16.25 9C16.25 13.0041 13.0041 16.25 9 16.25V17.75C13.8325 17.75 17.75 13.8325 17.75 9H16.25ZM9 16.25C4.99594 16.25 1.75 13.0041 1.75 9H0.25C0.25 13.8325 4.16751 17.75 9 17.75V16.25ZM1.75 9C1.75 4.99594 4.99594 1.75 9 1.75V0.25C4.16751 0.25 0.25 4.16751 0.25 9H1.75ZM9 1.75C13.0041 1.75 16.25 4.99594 16.25 9H17.75C17.75 4.16751 13.8325 0.25 9 0.25V1.75ZM9.53033 12.4394L12.8031 9.16669L11.7424 8.10603L8.46967 11.3788L9.53033 12.4394ZM8.25 1V2.45455H9.75V1H8.25ZM17 8.25H15.5455V9.75H17V8.25ZM2.45455 8.25H1V9.75H2.45455V8.25ZM3.37876 3.71215L4.40728 4.74067L5.46794 3.68001L4.43942 2.65149L3.37876 3.71215ZM13.8618 2.65149L12.8333 3.68001L13.8939 4.74067L14.9225 3.71215L13.8618 2.65149ZM2.81818 14.0909C3.39435 14.571 3.39408 14.5714 3.39381 14.5717C3.39374 14.5718 3.39348 14.5721 3.39332 14.5723C3.393 14.5727 3.39272 14.573 3.39245 14.5733C3.39193 14.5739 3.39151 14.5744 3.39119 14.5748C3.39057 14.5755 3.39037 14.5758 3.3906 14.5755C3.39106 14.575 3.39323 14.5725 3.39714 14.5681C3.40495 14.5594 3.41969 14.5434 3.44151 14.5211C3.48517 14.4763 3.55708 14.4064 3.65855 14.3194C3.86147 14.1455 4.1823 13.9036 4.63187 13.6584C5.52674 13.1703 6.9493 12.6591 9 12.6591V11.1591C6.68707 11.1591 5.01871 11.7388 3.91359 12.3416C3.36316 12.6418 2.95671 12.9454 2.68236 13.1806C2.5452 13.2981 2.44097 13.3987 2.36815 13.4733C2.33173 13.5106 2.30315 13.5414 2.2822 13.5647C2.27172 13.5763 2.26315 13.5861 2.25646 13.5938C2.25312 13.5977 2.25024 13.601 2.24784 13.6039C2.24663 13.6053 2.24555 13.6066 2.24458 13.6077C2.24409 13.6083 2.24364 13.6088 2.24321 13.6093C2.243 13.6096 2.2427 13.61 2.24259 13.6101C2.2423 13.6104 2.24202 13.6108 2.81818 14.0909ZM9 12.6591C11.0507 12.6591 12.4733 13.1703 13.3681 13.6584C13.8177 13.9036 14.1385 14.1455 14.3415 14.3194C14.4429 14.4064 14.5148 14.4763 14.5585 14.5211C14.5803 14.5434 14.595 14.5594 14.6029 14.5681C14.6068 14.5725 14.6089 14.575 14.6094 14.5755C14.6096 14.5758 14.6094 14.5755 14.6088 14.5748C14.6085 14.5744 14.6081 14.5739 14.6075 14.5733C14.6073 14.573 14.607 14.5727 14.6067 14.5723C14.6065 14.5721 14.6063 14.5718 14.6062 14.5717C14.6059 14.5714 14.6057 14.571 15.1818 14.0909C15.758 13.6108 15.7577 13.6104 15.7574 13.6101C15.7573 13.61 15.757 13.6096 15.7568 13.6093C15.7564 13.6088 15.7559 13.6083 15.7554 13.6077C15.7545 13.6066 15.7534 13.6053 15.7522 13.6039C15.7498 13.601 15.7469 13.5977 15.7435 13.5938C15.7369 13.5861 15.7283 13.5763 15.7178 13.5647C15.6969 13.5414 15.6683 13.5106 15.6319 13.4733C15.559 13.3987 15.4548 13.2981 15.3176 13.1806C15.0433 12.9454 14.6368 12.6418 14.0864 12.3416C12.9813 11.7388 11.3129 11.1591 9 11.1591V12.6591Z"
                  fill="#1E2028"
                />
              </svg>
              <div>Analyse</div>
            </div>
            <div className="box-description">
              Wide range of tools to help you analyse markets
            </div>
          </div>
          <div className="why-op-box d-flex flex-column gap-2 justify-content-center px-3">
            <div className="box-title d-flex align-items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="10"
                viewBox="0 0 16 10"
                fill="none">
                <path
                  d="M9.10953 1L15 1.00003M15 1.00003L15 7.15227M15 1.00003L9.03919 7.0289L6.09392 3.88639L1 9"
                  stroke="#1E2028"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div>Execute</div>
            </div>
            <div className="box-description">
              Execute orders directly in your broker post analysis
            </div>
          </div>
          <div className="why-op-box d-flex flex-column gap-2 justify-content-center px-3">
            <div className="box-title d-flex align-items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none">
                <path
                  d="M9.50018 10.1765V13.2353M9.50018 13.2353C10.7167 13.2353 12.5911 14 12.5911 14M9.50018 13.2353C8.28371 13.2353 6.40927 14 6.40927 14M1.00018 9.79412V1.38235C1.00018 1.17119 1.16834 1 1.38172 1C3.52895 1 14.134 1 17.6165 1C17.8299 1 18.0002 1.17119 18.0002 1.38235V9.79412C18.0002 10.0053 17.8299 10.1765 17.6165 10.1765C14.134 10.1765 3.52895 10.1765 1.38172 10.1765C1.16834 10.1765 1.00018 10.0053 1.00018 9.79412Z"
                  stroke="#1E2028"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
              <div>User-friendly</div>
            </div>
            <div className="box-description">
              Takes less than 5 mins to understand the platform
            </div>
          </div>
          
          <div>
            <div className="pricing-title" style={{"marginBottom": "20px"}}>Get all of this!</div>
            <div className="d-flex list-box">
              <ul className="custom-list">
                <li>Strategy creator</li>
                <li>Position analytics</li>
                <li>Unlimited orders</li>
                <li>Realtime market feed</li>
                <li>Realtime OI</li>
                <li>Basket order</li>
                <li>Instrument screener</li>
              </ul>
              <ul className="custom-list">
                <li>Prebuilt strategies</li>
                <li>Scalp orders</li>
                <li>Iceberg orders</li>
                <li>Option chain</li>
                <li>Manage orders</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="grid-container-mobile">
        <div className="d-flex justify-content-between">
          <div className="w-50">
            <div className="pricing-title">Pricing</div>
            <div className="price-desc">
              Introductory pricing till end of March 24
            </div>
          </div>
          <div className="text-end">
            <div className="strikethrough-text">₹ 499.00/-</div>

            <div className="bold-price">₹ 199.00/-</div>
            <div className="per-month">per month</div>
          </div>
        </div>
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
          <button
            className="get-started-btn d-flex align-items-center justify-content-center gap-2 mb-1"
            onClick={handleOpenPopup}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="21"
              viewBox="0 0 16 21"
              fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.0455 0.53125L0.795502 13.2188H8.04545V20.4687L15.2954 7.7812H8.0455V0.53125Z"
                fill="white"
              />
            </svg>
            <span>Get started</span>
          </button>
          <div>
            <span className="thirty-days">30 day’s free trail,</span>
            <span className="no-credit"> no credit cards required</span>
          </div>
        </div>
      </div>
      <div className="grid-container-mobile mb-3">
        <div className="pricing-title prc-mobile">FAQ’s</div>
        <div className="price-desc mb-2">
          Have more questions, feel free to reach out to us!
        </div>
        <div className="align-self-start">
          {questions.map((question, index) => (
            <div
              key={index}
              className={`faq-question ${
                expandedIndex === index ? "expanded" : ""
              }`}
              onClick={() => handleToggleAnswer(index)}>
              <div className="question-container d-flex align-items-start justify-content-between">
                <div className="d-flex">
                  <div className="question-number me-1">{index + 1}. </div>
                  <div className="actual-question">{question}</div>
                </div>

                <div className="arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className={`${expandedIndex === index ? "inverted" : ""}`}>
                    <path
                      d="M18.9263 10L11.9631 16.9632L4.99994 10"
                      stroke="#14142B"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              {expandedIndex === index && (
                <div className="faq-answer">{answers[index]}</div>
              )}
            </div>
          ))}
        </div>
      </div>
      {isPopupOpen && <MultiStepForm onClose={handleClosePopup} />}
    </div>
  );
};

export default MainMobile;
